import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getOneEventAction } from "../../store/eventManagement/actions";
import { useDispatch } from "react-redux";
import EventDetailsCard from "../card/EventDetailsCard";

const EventDetails = () => {
  const dispatch = useDispatch();
  const { eventId } = useParams();

  useEffect(() => {
    if (eventId) {
      getOneEventAction(eventId)(dispatch);
    }
  }, [dispatch, eventId]);

  return <EventDetailsCard />;
};

export default EventDetails;
